<template>
  <div class="case-detail-content">
    <div class="case-detail-title">
      {{ customerCaseList[0] && customerCaseList[0].caseName }}
    </div>
    <div class="case-detail-big-img">
      <img
        :src="customerCaseList[0] && customerCaseList[0].mainPicture"
        alt=""
      />
    </div>
    <div class="case-detail-small-img">
      <img
        :src="customerCaseList[0] && customerCaseList[0].detailPicture1"
        alt=""
      />
      <img
        :src="customerCaseList[0] && customerCaseList[0].detailPicture2"
        alt=""
      />
    </div>
    <div class="case-detail-text">
      <div class="case-detail-text-title">{{ $t("case.background") }} :</div>
      <div class="case-detail-text-content" v-html="customerCaseList[0] && customerCaseList[0].projectBackground
"></div>
    </div>
    <div class="case-detail-text">
      <div class="case-detail-text-title">{{ $t("case.resolved") }} :</div>
      <div class="case-detail-text-content" v-html="customerCaseList[0] && customerCaseList[0].solveProblem">
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/axios/index.js";

export default {
  name: "home",
  props: {
    msg: String,
  },
  data() {
    return {
      lang: this.$i18n.locale,
      params: {
        page: 1,
        pageSize: 15,
        orders: { sequence: "desc" },
        param: {
          id: "",
          lang: "zh_CN",
        },
      },
      customerCaseList: [{ caseName: "" }],
    };
  },
  created() {
    if (this.$i18n.locale === "zh") {
      this.params.param.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.params.param.lang = "en";
    }
    this.customerCaseList = [];
    this.params.param.id = this.$route.query.id;
    this.getCustomerCaseList();
  },
  methods: {
    // 获取详情信息
    getCustomerCaseList() {
      const url = `/frontCustomerCase/page`;
      http
        .post(url, this.params)
        .then((res) => {
          if (res.code === "00000") {
            this.customerCaseList = res.data.list;
            // 使用vue-lazyload,所有的img标签的src属性改为data-src
            this.customerCaseList[0].projectBackground =
              this.customerCaseList[0].projectBackground.replace(
                /src/g,
                "data-src"
              );
            this.customerCaseList[0].solveProblem =
              this.customerCaseList[0].solveProblem.replace(/src/g, "data-src");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.case-detail-content {
  display: flex;
  flex-direction: column;
  width: 100vw;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 9.2rem 4rem 6rem 4rem;
  align-items: center;
  .case-detail-title {
    box-sizing: border-box;
    padding-bottom: 4.2rem;
    font-size: 4rem;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #2b2b2b;
  }
  .case-detail-big-img {
    width: 67rem;
    height: 48.2rem;
    box-sizing: border-box;
    padding-bottom: 3.2rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .case-detail-small-img {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 2rem;
    display: flex;
    justify-content: space-between;
    img {
      width: 32rem;
      height: 20rem;
    }
  }
  .case-detail-text {
    box-sizing: border-box;
    padding-bottom: 2rem;
    .case-detail-text-title {
      box-sizing: border-box;
      padding-bottom: 2rem;
      font-size: 2.8rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2b2b2b;
    }
    .case-detail-text-content {
      // letter-spacing:.6rem;
      font-size: 2rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2b2b2b;
    }
  }
}
</style>
